/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface Contact
 */
export interface Contact {
  /**
   *
   * @type {number | null}
   * @memberof Contact
   */
  companyId?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof Contact
   */
  companyName?: string | null;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  contactId?: string;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  contactType?: string;
  /**
   *
   * @type {number}
   * @memberof Contact
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string | null}
   * @memberof Contact
   */
  email?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Contact
   */
  emails?: Array<any>;
  /**
   *
   * @type {string | null}
   * @memberof Contact
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  id: string;
  /**
   *
   * @type {string | null}
   * @memberof Contact
   */
  jobTitle?: string | null;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  key: string;
  /**
   *
   * @type {string | null}
   * @memberof Contact
   */
  lastName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Contact
   */
  name?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof Contact
   */
  phoneNumber?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof Contact
   */
  phones?: Array<any>;
}

/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value: object): value is Contact {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function ContactFromJSON(json: any): Contact {
  return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Contact {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'] == null ? undefined : json['company_id'],
    companyName:
      json['company_name'] == null ? undefined : json['company_name'],
    contactId: json['contact_id'] == null ? undefined : json['contact_id'],
    contactType:
      json['contact_type'] == null ? undefined : json['contact_type'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    email: json['email'] == null ? undefined : json['email'],
    emails: json['emails'] == null ? undefined : json['emails'],
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    id: json['id'],
    jobTitle: json['job_title'] == null ? undefined : json['job_title'],
    key: json['key'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    name: json['name'] == null ? undefined : json['name'],
    phoneNumber:
      json['phone_number'] == null ? undefined : json['phone_number'],
    phones: json['phones'] == null ? undefined : json['phones'],
  };
}

export function ContactToJSON(value?: Contact | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    company_name: value['companyName'],
    contact_id: value['contactId'],
    contact_type: value['contactType'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    email: value['email'],
    emails: value['emails'],
    first_name: value['firstName'],
    id: value['id'],
    job_title: value['jobTitle'],
    key: value['key'],
    last_name: value['lastName'],
    name: value['name'],
    phone_number: value['phoneNumber'],
    phones: value['phones'],
  };
}
